import { platformApi } from "@/api/http";

export interface BusinessAddress {
  id: number;
  businessId: number;
  street: string;
  city: string;
  state?: string;
  postalCode?: string;
  country: string;
}

const basePath = (businessId: string) =>
  `/api/v1/businesses/${businessId}/addresses`;

export async function getBusinessAddresses(
  businessId: string,
): Promise<BusinessAddress[]> {
  const response = await platformApi.get<unknown>(basePath(businessId));
  const data = response.data;
  if (Array.isArray(data)) return data as BusinessAddress[];
  if (data && typeof data === "object") {
    const obj = data as Record<string, unknown>;
    const arr =
      (obj.content as BusinessAddress[] | undefined) ??
      (obj.data as BusinessAddress[] | undefined) ??
      (obj.items as BusinessAddress[] | undefined) ??
      (obj.addresses as BusinessAddress[] | undefined);
    if (Array.isArray(arr)) return arr;
  }
  return [];
}
